























































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import RiwayatObatPasienSvc from "@/services/RiwayatObatPasien";
import { RiwayatObatEntri, RiwayatObatPasien } from "@/types/riwayat_obat";
import {
  WARNA_STATUS_RIWAYAT_OBAT,
  cocokPencarianRiwayatObat,
  formatBulanPartisi,
  keteranganRiwayatObat,
  keteranganSalinRiwayatObat,
  labelStatusRiwayatObat,
  ringkasanRiwayatObat
} from "@/utils/riwayatObat";

@Component
export default class RiwayatObatPanel extends Vue {
  @Prop({ default: null }) rm!: string | number | null;
  @Prop({ default: null }) registerId!: string | number | null;
  @Prop({ default: () => [] }) obatTerpakai!: string[];
  @Prop({ type: Boolean, default: false }) aktif!: boolean;
  @Prop({ type: Boolean, default: false }) nonaktif!: boolean;

  bulan = 6;
  pilihanBulan = [
    { text: "3 bulan", value: 3 },
    { text: "6 bulan", value: 6 },
    { text: "12 bulan", value: 12 }
  ];
  cari = "";
  memuat = false;
  galat = false;
  hasil: RiwayatObatPasien | null = null;
  kunciTermuat = "";
  nomorPermintaan = 0;

  get semua(): RiwayatObatEntri[] {
    return this.hasil ? this.hasil.data : [];
  }

  get tersaring(): RiwayatObatEntri[] {
    return this.semua.filter(entri =>
      cocokPencarianRiwayatObat(entri, this.cari)
    );
  }

  get lengkap(): boolean {
    return !this.hasil || this.hasil.lengkap;
  }

  get bulanGagal(): string {
    return this.hasil
      ? this.hasil.bulan_gagal.map(formatBulanPartisi).join(", ")
      : "";
  }

  get bulanTampil(): number {
    return this.hasil ? this.hasil.periode.bulan : this.bulan;
  }

  get terpotong(): boolean {
    return !!this.hasil && this.hasil.jumlah_obat > this.semua.length;
  }

  get kunciPasien(): string {
    return `${this.rm || ""}|${this.registerId || ""}`;
  }

  get kunciPermintaan(): string {
    return `${this.kunciPasien}|${this.bulan}`;
  }

  mounted() {
    this.muatBilaPerlu();
  }

  @Watch("kunciPasien")
  gantiPasien() {
    this.nomorPermintaan++;
    this.hasil = null;
    this.galat = false;
    this.memuat = false;
    this.cari = "";
    this.kunciTermuat = "";
    this.muatBilaPerlu();
  }

  @Watch("aktif")
  gantiAktif(aktif: boolean) {
    if (!aktif) {
      this.kunciTermuat = "";
      return;
    }
    this.muatBilaPerlu();
  }

  @Watch("bulan")
  muatBilaPerlu() {
    if (!this.aktif || !this.rm || this.kunciTermuat === this.kunciPermintaan) {
      return;
    }
    this.muat();
  }

  async muat() {
    if (!this.rm) {
      return;
    }

    const nomor = ++this.nomorPermintaan;
    const kunci = this.kunciPermintaan;
    this.memuat = true;
    this.galat = false;

    try {
      const hasil = await RiwayatObatPasienSvc.riwayatObat(this.rm, {
        bulan: this.bulan,
        kecuali_register: this.registerId ? Number(this.registerId) : null
      });

      if (nomor !== this.nomorPermintaan) {
        return;
      }

      this.hasil = hasil;
      this.kunciTermuat = kunci;
    } catch (e) {
      if (nomor !== this.nomorPermintaan) {
        return;
      }
      this.hasil = null;
      this.galat = true;
      this.kunciTermuat = "";
    } finally {
      if (nomor === this.nomorPermintaan) {
        this.memuat = false;
      }
    }
  }

  sudahDiResep(entri: RiwayatObatEntri): boolean {
    return this.obatTerpakai.includes(entri.obat_id);
  }

  ringkasan(entri: RiwayatObatEntri): string {
    return ringkasanRiwayatObat(entri);
  }

  label(entri: RiwayatObatEntri): string {
    return labelStatusRiwayatObat(entri);
  }

  warna(entri: RiwayatObatEntri) {
    return (
      WARNA_STATUS_RIWAYAT_OBAT[entri.terakhir.status] ||
      WARNA_STATUS_RIWAYAT_OBAT.tidak_diketahui
    );
  }

  keterangan(entri: RiwayatObatEntri): string {
    return keteranganRiwayatObat(entri, this.bulanTampil);
  }

  keteranganSalin(entri: RiwayatObatEntri): string {
    return keteranganSalinRiwayatObat(entri);
  }
}
